import React, { useState, useRef } from 'react'
import { extend, Canvas, useFrame } from 'react-three-fiber'
import { Text } from 'troika-three-text'
import fonts from './fonts'
import { useSpring, animated } from 'react-spring/three'
import * as THREE from 'three'
// import { Blotter } from './blotter.js'
// console.log(Blotter)

extend({ Text })

interface Props {
  title: string
  text: string
}

export const NoisyText = ({ title, text }: Props) => {
  const [opts, setOpts] = useState({
    font: 'DmSerifDisplayWoff',
    fontSize: 28,
    color: '#202346',
    maxWidth: 300,
    lineHeight: 1.3,
    letterSpacing: 0,
    textAlign: 'center'
  })

  const flagShader = {
    uniforms: {
      wind: {
        type: 'f',
        value: 0.0
      }
    },
    fragmentShader: `
    void main(){
        gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
    }
  `,
    vertexShader: `
    void main() {
      vec4 modelViewPosition = modelViewMatrix * vec4(position, 1.0);
      gl_Position = projectionMatrix * modelViewPosition; 
    }
  `
  }

  return (
    <Canvas
      colorManagement={false}
      style={{
        width: '100%',
        height: '600px'
      }}
      pixelRatio={window.devicePixelRatio}
    >
      <text
        position-z={-180}
        {...opts}
        text={title}
        font={fonts[opts.font]}
        anchorX='center'
        anchorY='middle'
      >
        <meshBasicMaterial attach='material' color={opts.color} />
      </text>
      <text
        position-z={-180}
        position-y={-60}
        {...opts}
        fontSize={10}
        text={text}
        font={fonts[opts.font]}
        anchorX='center'
        anchorY='middle'
      >
        {/* <meshBasicMaterial attach='material' color={opts.color} /> */}
        <animated.shaderMaterial
          attach='material'
          uniforms-wind-value={1}
          args={[{ ...flagShader }]}
          side={THREE.DoubleSide}
        />
      </text>
    </Canvas>
  )
}
